<div *ngIf="visible" class="overlay" (click)="closable ? close() : null"></div>
<div [@dialog] *ngIf="visible" [ngStyle]="cssStyle" class="dialog {{ cssClass }}">
    <ng-content></ng-content>
    <app-button
        *ngIf="closable && showCloseButton"
        (click)="close()"
        aria-label="Close"
        cssClass="ghost transparent btn-x-sm"
        icon="Close"
        class="dialog__close-btn"
    >
    </app-button>
</div>
